/* Arquivo de configuração que lê json */
/* Criado por Carlos Eduardo em 14/01/2019 */
/* Em caso de dúvidas: contato.carlos@outlook.com */

export default function Config(index) {
  let data = require('./config.json');
  return data[index];
}
